export default {
    init() {
        // JavaScript to be fired on the about us page
        this.topMenuHeight = 0;
        this.topMenu = null;
        this.menuItems = null;
        this.scrollItems = null;

    },
    finalize() {
        $(document.body).scrollspy({
            target: '.page__header',
        })
        
    },
    onScroll() {
        // Get container scroll position
        var fromTop = $(window).scrollTop() + this.topMenuHeight;

        // Get id of current scroll item
        var cur = this.scrollItems.map(function() {
            if ($(this).offset().top < fromTop)
                return this;
        });
        // Get the id of the current element
        cur = cur[cur.length - 1];
        var id = cur && cur.length ? cur[0].id : '';
        // Set remove active class
        console.log(id);
        this.menuItems.removeClass('active');
        this.topMenu.find('[href="#' + id + '"]').addClass('active');
        // this.menuItems.parent().removeClass('active').end().filter('[href="#" ' + id + ']').parent().addClass('active');
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/landing/temperaturescanner.js